import { Component } from '@angular/core';

@Component({
    selector: 'mst-layout-login',
    template: `
    <router-outlet></router-outlet>
`,
    styles: []
})
export class LayoutLoginComponent { }
